import { all, put, call, takeEvery, select } from 'redux-saga/effects';

import { agentActions } from '$store/agent/index';
import { Api } from '$api';
import { batchActions } from '$store';
import { mainActions } from '$store/main';
import { LoadMainAction, LoadUserAction } from '$store/agent/interface';

function* loadMainWorker(action: LoadMainAction) {
  try {
    const data = yield call(Api.get, `/agent/${action.payload}`);

    yield put(
      batchActions(
        agentActions.setMainLoaded({
          balance: data.balance,
          users: data.invited,
          operations: data.operations,
          withdrawals: data.withdrawals,
        }),
        mainActions.setUsers(data.users),
      ),
    );
  } catch (e) {
    yield put(agentActions.setMainFailed());
  }
}

function* loadUserWorker(action: LoadUserAction) {
  try {
    const data = yield call(Api.get, `/agent/user/${action.payload}`);
    yield put(
      batchActions(
        agentActions.setUserLoaded({
          balance: data.balance,
          operations: data.operations,
          canPay: data.canPay,
        }),
        mainActions.setUsers(data.users),
      ),
    );
  } catch (e) {
    yield put(agentActions.setUserFailed());
  }
}

export function* agentSaga() {
  yield all([
    takeEvery(agentActions.loadMain, loadMainWorker),
    takeEvery(agentActions.loadUser, loadUserWorker),
  ]);
}
